import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {parseDate} from "@internationalized/date";
import {Button, DateRangePicker, Table} from "aria";
import formatters from "helpers/formatters.jsx";
import moment from "moment";
import {useEffect, useState} from "react";
import MainChart from "./mainChart.tsx";
import SalesChart from "@/views/app/admin/salesChart.jsx";

export default function Dashboard(props) {
  return (
    <>
      <div className="p-2 max-w-[95%] mx-auto text-black fill-gray-800">
        <SalesChart />
      </div>
    </>
  )
}